<template>
  <div class="content-body">
    <div class="top">操作日志</div>
    <div class="body">
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            日期:
            <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
          <div class="demo-input-suffix">
            操作账号:
            <el-select v-model="form.plan_id" size="small" style="width: 130px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="1" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            操作对象名称:
            <el-input v-model="form.adv_name" placeholder="" style="width: 120px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            操作对象ID:
            <el-input v-model="form.adv_id" placeholder="" style="width: 120px; margin-left: 10px;" size="small"></el-input>
          </div>
          <div class="demo-input-suffix">
            操作类型:
            <el-select v-model="form.type" size="small" style="width: 140px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in options" :key="index"></el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>

          <div style="margin: 20px 0;"></div>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 1350px;" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
            <el-table-column width="160" label="操作时间" align="center">
              <template slot-scope="scope">
                {{ getDate(scope.row.create_at) }}
              </template>
            </el-table-column>
            <el-table-column label="操作账号" width="200" align="center">
              <template>
                1231
              </template>
            </el-table-column>
            <el-table-column label="操作对象类型" width="160" align="center">
              <template>
                广告计划
              </template>
            </el-table-column>
            <el-table-column prop="adv_name" label="操作对象名称" width="160" align="center"></el-table-column>
            <el-table-column prop="adv_id" label="操作对象ID" width="120" align="center"></el-table-column>
            <el-table-column prop="cpm" label="操作类型" width="199" align="center">
              <template slot-scope="scope">
                {{ type[scope.row.type] }}
              </template>
            </el-table-column>
            <el-table-column prop="content" label="操作后" width="350" align="center"></el-table-column>
          </el-table>
          <div class="page-c">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 40, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bill',
  data() {
    return {
      form: {
        adv_name: '',
        type: '',
        plan_id: '',
        adv_id: '',
        pay_time: []
      },
      type: ['', '新增', '复制', '', '修改价格', '修改预算', '开启', '关闭', '删除'],
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      options: [{
        value: '6',
        label: '开关开启'
      }, {
        value: '7',
        label: '开关关闭'
      }, {
        value: '2',
        label: '复制'
      }, {
        value: '8',
        label: '删除'
      }, {
        value: '5',
        label: '修改预算'
      }, {
        value: '4',
        label: '修改出价'
      }, {
        value: '1',
        label: '新建广告'
      }]
    };
  },
  mounted() {
    this.setTimeInit();
    this.getData();
  },
  methods: {
    getData() {
      this.form = Object.assign({}, this.form, { page: this.page, pageSize: this.pageSize });
      this.$http.post('/trader/data/getLog', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = res.count;
          this.$function.hiddenLoading();
        }
      });
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 7);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.form.pay_time = [preToday, today];
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    getDate(time) {
      return this.$function.formatDate(time);
    }
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding-left: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-z {
      display: flex;
    }
    .status {
      font-size: 14px;
      color: #999;
      font-weight: 400;
      margin-left: 30px;
      span {
        color: #0782c3;
      }
    }
    .btn {
      float: right;
      margin-right: 40px;
    }
  }

  .body {
    padding: 0px 44px;
  }

  .condition {
    margin-top: 20px;
    width: 1350px;
    height: 55px;
    .form {
      float: left;
      width: 1350px;
    }
    .other {
      float: right;
      width: 440px;
    }
    .demo-input-suffix {
      display: inline-block;
      font-size: 14px;
      color: #999;
      margin-right: 31px;
    }
  }
  .page-c {
    margin-top: 20px;
    text-align: right;
  }



</style>
